export default "__VITE_ASSET__BYttJYYx__"